var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.displayPaymentMethodControl()
    ? _c(
        "div",
        {
          staticClass: "field payment-method",
          attrs: { role: "radiogroup", "aria-label": "Payment Options" }
        },
        [
          _vm.displayPayLaterButton()
            ? _c("BaseRadio", {
                attrs: {
                  name: _vm.payLaterTitle(),
                  activeClass: _vm.isPayLaterActive(),
                  click: _vm.handlePayLaterClick,
                  ariaLabel: "Pay later in person",
                  "aria-checked": _vm.isPayLater
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.displayPayNowButton()
            ? _c("BaseRadio", {
                attrs: {
                  name: _vm.payNowTitle(),
                  activeClass: _vm.isPayNowActive(),
                  click: _vm.handlePayNowClick,
                  ariaLabel: "Pay now online",
                  "aria-checked": _vm.isPayNow
                }
              })
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0ee542bf", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ee542bf","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/checkout/PaymentMethodControl.vue
// module id = null
// module chunks = 